import React from "react";
import KalturaYouTubePlayer from "./KalturaYouTubePlayer";
import { PreviewContainer, VideoContainer, LoadingContainer } from "./StyleComponents";
import { YouTubeVideoData } from "./types";

export interface YouTubePreviewProps {
    videoData: YouTubeVideoData;
    baseUrl?: string; // No longer needed but kept for backward compatibility
    partnerId: number;
    uiconfId?: string;
    cdnUrl?: string;
}

/**
 * YouTubePreview is a presentational component for displaying a preview of a YouTube video.
 * It uses KalturaYouTubePlayer to embed the video and shows the video title and loading state.
 * Used within the YouTube import workflow to provide a visual preview before import.
 */
const YouTubePreview: React.FC<YouTubePreviewProps> = ({ videoData, partnerId, uiconfId, cdnUrl }) => {
    return (
        <PreviewContainer data-testid="youtube-import-modal-preview-container">
            <VideoContainer>
                <LoadingContainer></LoadingContainer>
                <KalturaYouTubePlayer
                    youtubeId={videoData.id}
                    title={videoData.title}
                    partnerId={partnerId}
                    uiconfId={uiconfId}
                    cdnUrl={cdnUrl}
                />
            </VideoContainer>
        </PreviewContainer>
    );
};

export default YouTubePreview;
